import React, { FC, Suspense } from 'react';
import { ThemeProvider } from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import { Loading } from '@minecraft.loader';
import { CoreTheme } from '@minecraft.themes';
import { NotificationProvider } from '@minecraft.notification-provider';
import { getEnvironment } from '@minecraft.environment';
import { UserContextProvider } from '@blocs.auth';
import { FeatureExperimentProvider } from '@blocs.features-experiments';
import { MaintenanceGuard } from '@blocs.maintenance';
import { AppKey, InternationalizationProvider } from '@blocs.i18n';
import ImpactedServiceAlert from '@blocs.impacted-service-alert';
import Routes from 'src/routes';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { WindowWidthContext } from '@minecraft.utils';
import { AnalyticsProvider } from '@blocs.analytics';
import createApolloClient from '../lib/createApolloClient';

const App: FC = () => {
  const environment = getEnvironment();
  const apolloClient = createApolloClient();

  return (
    <Suspense fallback={<Loading />}>
      <InternationalizationProvider appName={AppKey.TALENT} namespaces={['talent']}>
        <FeatureExperimentProvider>
          <ApolloProvider client={apolloClient}>
            <GoogleOAuthProvider clientId={environment.GOOGLE_AUTH_CLIENT_ID}>
              <UserContextProvider>
                <AnalyticsProvider>
                  <ThemeProvider theme={CoreTheme}>
                    <NotificationProvider>
                      <ImpactedServiceAlert />
                      <MaintenanceGuard routes={Routes} />
                    </NotificationProvider>
                  </ThemeProvider>
                </AnalyticsProvider>
              </UserContextProvider>
            </GoogleOAuthProvider>
          </ApolloProvider>
        </FeatureExperimentProvider>
      </InternationalizationProvider>
    </Suspense>
  );
};

export default WindowWidthContext.withWidthDataProvider(React.memo(App));
